import React, { Component } from 'react'
import OptionsDropdown from '~/Common-Objects/UI/OptionsDropdown/OptionsDropdown'
import SquareChip from '~/Common-Objects/UI/Chips/SquareChip.jsx'

class CreditCard extends Component {
    constructor(props) {
        super(props)
    }
    render() {
        var classes = 'quickFlex'
        if (this.props.default == this.props.card.id) classes += ' default'
        return (
            <div className={classes} style={{ justifyContent: 'space-between', alignItems: 'center', height: 32 }}>
                <div className='quickFlex' style={{ alignItems: 'center', gap: 12 }}>
                    <img
                        style={{ width: '32px', borderRadius: '3px' }}
                        src={'/public/cards/' + this.props.card.brand.toLowerCase() + '.png'}
                    />
                    <div>
                        {this.props.card.brand} ending in {this.props.card.last4}
                    </div>
                    {this.props.default == this.props.card.id && <SquareChip>Primary</SquareChip>}
                </div>
                <div className='quickFlex' style={{ justifyContent: 'end', flexGrow: 1 }}>
                    {(this.props.allowDelete || this.props.default !== this.props.card.id) && !this.props.readOnly && (
                        <OptionsDropdown popWidth='150px' top={10} removeOnClose={true}>
                            <ul>
                                {this.props.default !== this.props.card.id && (
                                    <li>
                                        <a onClick={() => this.props.makeDefault(this.props.card.id)}>Make Primary</a>
                                    </li>
                                )}
                                {this.props.allowDelete && (
                                    <li>
                                        <a onClick={() => this.props.deleteCard(this.props.card.id)}>Delete Card</a>
                                    </li>
                                )}
                            </ul>
                        </OptionsDropdown>
                    )}
                </div>
            </div>
        )
    }
}

export default CreditCard
